module.exports = __webpack_public_path__ + "img/kat.9d5dbf6f.jpg";